/**
 * Commentary history list — slide-out overlay showing the last 12 generated
 * AI commentaries (localStorage-backed). Clicking one recalls it into the
 * viewer without another generation run. Reuses the conversation-list CSS.
 */

import { observer } from 'mobx-react-lite';
import { bibleState } from '@/state/bible-state';
import { commentaryHistory } from '@state/chat';
import { SparklesIcon, TrashIcon, CloseIcon } from '@components/icons';
import { relativeTime } from './conversation-list';

export const CommentaryHistoryList = observer(function CommentaryHistoryList() {
  const entries = commentaryHistory.entries;

  return (
    <div className="conversation-list" data-testid="commentary-history-list">
      <div className="conversation-list-header">
        <span className="flex items-center gap-1.5 text-sm font-semibold text-stone-700 dark:text-stone-300">
          <SparklesIcon className="h-4 w-4 text-cyan-500" />
          It is written… history
        </span>
        <button
          onClick={() => bibleState.hideCommentaryHistory()}
          className="conversation-list-btn"
          title="Close"
        >
          <CloseIcon className="h-4 w-4" />
        </button>
      </div>

      <div className="conversation-list-items">
        {entries.length === 0 && (
          <p className="px-3 py-4 text-center text-sm text-stone-400">
            No commentaries yet — generate one from a passage study.
          </p>
        )}

        {entries.map((entry) => (
          <div
            key={entry.id}
            className="conversation-item"
            onClick={() => bibleState.showCommentaryFromHistory(entry)}
          >
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-stone-800 dark:text-stone-200">
                {entry.pericopeTitle ?? entry.reference}
              </p>
              <p className="truncate text-xs text-stone-400 dark:text-stone-500">
                {entry.reference} &middot; {relativeTime(entry.generatedAt)}
              </p>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                commentaryHistory.remove(entry.id);
              }}
              className="ml-1 flex-shrink-0 rounded p-1 text-stone-300 transition-colors hover:text-red-500 dark:text-stone-600 dark:hover:text-red-400"
              title="Remove from history"
            >
              <TrashIcon className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
});
